import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "gfu-box-divider _mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-table"
}
const _hoisted_3 = { class: "_flexcntr _flexwrap" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gfu-heading gfu-heading--top-divider _mt-3 _mb-2" }
const _hoisted_6 = { class: "gfu-heading gfu-heading--top-divider _mt-3" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "_mt-4 _pa-4 _bg-color-light _brad--common" }
const _hoisted_9 = { class: "_flex _gap-2 _mb-4 _ai-c" }
const _hoisted_10 = { class: "_tc--light" }
const _hoisted_11 = { class: "gfu-list _flexcol _gap-2" }
const _hoisted_12 = { class: "_flex _ai-c" }
const _hoisted_13 = { class: "gfu-bt gfu-bt--b2 _mb-3 _mt-2" }
const _hoisted_14 = { class: "gfu-box-actions _mt-3" }
const _hoisted_15 = { class: "_ml-a" }
const _hoisted_16 = {
  key: 3,
  class: "gfu-box-actions"
}
const _hoisted_17 = {
  key: 0,
  class: "gfu-box-actions__item gfu-box-actions__item--link"
}
const _hoisted_18 = {
  key: 1,
  class: "gfu-box-actions__item"
}
const _hoisted_19 = { class: "gfu-box-actions__item _ml-a" }
const _hoisted_20 = {
  type: "button",
  class: "gfu-btn gfu-btn--soft gfu-btn--accent gfu-btn--block",
  disabled: "disabled",
  "data-qa": "your-pledge-checkout-btn"
}
const _hoisted_21 = {
  key: 4,
  class: "gfu-box-actions"
}
const _hoisted_22 = { class: "gfu-box-actions__item _ml-a" }
const _hoisted_23 = ["href", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notificator = _resolveComponent("notificator")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_project_user_pledge_meta = _resolveComponent("project-user-pledge-meta")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_legacy_cart_table = _resolveComponent("legacy-cart-table")
  const _component_product_recommendation_slider = _resolveComponent("product-recommendation-slider")
  const _component_legacy_order_summary_list = _resolveComponent("legacy-order-summary-list")
  const _component_order_details_summary = _resolveComponent("order-details-summary")
  const _component_order_details_shipping = _resolveComponent("order-details-shipping")
  const _component_order_partial_details_shipping = _resolveComponent("order-partial-details-shipping")
  const _component_localize = _resolveComponent("localize")
  const _component_base_image = _resolveComponent("base-image")
  const _component_credit_card_overview = _resolveComponent("credit-card-overview")
  const _component_base_button = _resolveComponent("base-button")
  const _component_adyen_order_payment_options = _resolveComponent("adyen-order-payment-options")
  const _component_project_promo_item = _resolveComponent("project-promo-item")
  const _component_go_to_checkout = _resolveComponent("go-to-checkout")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_pledge_payment_history_modal = _resolveComponent("pledge-payment-history-modal")
  const _component_order_stage_history_modal = _resolveComponent("order-stage-history-modal")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notificator, {
      ref: "notifyImported",
      class: "_mt-3",
      singular: true,
      "can-close": false
    }, null, 512 /* NEED_PATCH */),
    _createVNode(_component_box, { "data-qa": "project-user-pledge:CurrentPledgeBox" }, {
      balloon: _withCtx(() => [
        _createVNode(_component_balloon_actions, {
          actions: $options.actions,
          "balloon-style-props": $options.balloonStyleProps,
          mode: $data.balloonActionsModes.grouped,
          "data-qa": "project-user-pledge:BalloonActions"
        }, null, 8 /* PROPS */, ["actions", "balloon-style-props", "mode"])
      ]),
      default: _withCtx(() => [
        ($options.isPledgePlaced)
          ? (_openBlock(), _createBlock(_component_project_user_pledge_meta, {
              key: 0,
              pledge: $options.metaPledgeModel,
              "is-open-for-orders": $props.isOpenForOrders,
              "is-editing": $options.canRevertChanges,
              "is-expanded": $data.isExpanded,
              "is-expandable": $props.isExpandable,
              "can-proceed-to-checkout": $options.canProceedToCheckout,
              labels: $options.labels,
              onCtaTriggered: $options.onMetaCtaTriggered,
              onExpand: $options.onToggleMore
            }, null, 8 /* PROPS */, ["pledge", "is-open-for-orders", "is-editing", "is-expanded", "is-expandable", "can-proceed-to-checkout", "labels", "onCtaTriggered", "onExpand"]))
          : _createCommentVNode("v-if", true),
        (!$props.isExpandable || $data.isExpanded)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _withDirectives(_createElementVNode("div", _hoisted_1, null, 512 /* NEED_PATCH */), [
                [_vShow, $options.isPledgePlaced]
              ]),
              ($options.allItemsRemoved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_empty_state, {
                      description: _ctx.Resources.YourPledge.EmptyPledgeRemovedAllItems,
                      "show-divider": false
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("a", {
                            class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--micro _ttl gfu-btn--thin gfu-empty-state-action _tlc",
                            href: $props.addNewItemsUrl,
                            "data-qa": "your-pledge-empty-state:AddItems"
                          }, [
                            _createVNode(_component_base_icon, {
                              name: "plus",
                              class: "gfu-btn__icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.Resources.YourPledge.AddItemsButton), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_4),
                          _createElementVNode("div", null, [
                            _createVNode(_component_icon_base_button, {
                              icon: "undo",
                              class: "gfu-empty-state-action _tlc",
                              onClick: $options.revertChanges,
                              "data-qa": "your-pledge-empty-state:RevertChanges"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.RevertChangesButton), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            ($props.pledge.canBeCanceled)
                              ? (_openBlock(), _createBlock(_component_icon_base_button, {
                                  key: 0,
                                  icon: "times",
                                  class: "gfu-empty-state-action _tlc",
                                  onClick: $options.onCancelOrder,
                                  "data-qa": "your-pledge-empty-state:CancelPledge"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.CancelPledgeButton), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["description"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(), _createBlock(_component_legacy_cart_table, {
                      key: $props.pledge.cartTableOrderCode || $props.pledge.orderPublicID,
                      ref: "cartTable",
                      "cart-behavior": $props.pledge.cartTableBehavior,
                      "copy-shipping-info": false,
                      "include-current-cart": $props.pledge.includeCurrentCart,
                      "order-code": $props.pledge.cartTableOrderCode,
                      "project-id": $props.pledge.projectID,
                      "recalculate-order": $props.pledge.includeCurrentCart,
                      onCartLoaded: $options.onCartLoaded,
                      onCartChanged: $options.onCartChanged,
                      onTableEmptied: $options.onTableEmptied,
                      onCartInvalid: _cache[0] || (_cache[0] = $event => ($options.onCartValidStatusChange(false))),
                      onCartValid: _cache[1] || (_cache[1] = $event => ($options.onCartValidStatusChange(true)))
                    }, null, 8 /* PROPS */, ["cart-behavior", "include-current-cart", "order-code", "project-id", "recalculate-order", "onCartLoaded", "onCartChanged", "onTableEmptied"])),
                    ($options.isProductRecommendationsVisible)
                      ? (_openBlock(), _createBlock(_component_product_recommendation_slider, {
                          key: 0,
                          "order-code": $options.orderCode,
                          "project-id": _ctx.projectContext.projectID,
                          section: "upsells-your-pledge",
                          "extra-large-screen-visible-items-count": 3,
                          "large-screen-visible-items-count": 3,
                          quantity: 9,
                          onProductAdded: $options.onEditPledge
                        }, null, 8 /* PROPS */, ["order-code", "project-id", "onProductAdded"]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_legacy_order_summary_list, { "order-id": $options.orderId }, null, 8 /* PROPS */, ["order-id"]),
                    ($options.isPledgePlaced)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_order_details_summary, {
                            "order-details": $props.pledge.pledgeDetails,
                            "order-id": $props.pledge.orderID,
                            "can-remove-unpaid-items": $props.pledge.canRemoveUnpaidItems,
                            "can-add-more-items": $props.pledge.canAddNewItems,
                            "can-resume-payment": $props.pledge.canResumePayment,
                            "can-cancel-order": $props.pledge.canBeCanceled,
                            onCancelOrder: $options.onCancelOrder,
                            onResumeOrder: $options.onResumeOrder,
                            onRemoveUnpaidItems: $options.removeUnpaidItems,
                            onAddItemsToOrder: $options.onAddItemsToOrder,
                            onEditPledge: $options.onEditPledge
                          }, null, 8 /* PROPS */, ["order-details", "order-id", "can-remove-unpaid-items", "can-add-more-items", "can-resume-payment", "can-cancel-order", "onCancelOrder", "onResumeOrder", "onRemoveUnpaidItems", "onAddItemsToOrder", "onEditPledge"]),
                          ($options.hasFullAddress)
                            ? (_openBlock(), _createBlock(_component_order_details_shipping, {
                                key: 0,
                                "billing-address": $options.billingAddress,
                                "shipping-address": $options.shippingAddress,
                                "can-change-shipping-address": $props.pledge.canChangeShipping,
                                onChangeShipping: $options.onChangeShipping
                              }, null, 8 /* PROPS */, ["billing-address", "shipping-address", "can-change-shipping-address", "onChangeShipping"]))
                            : ($options.hasPartialAddress)
                              ? (_openBlock(), _createBlock(_component_order_partial_details_shipping, {
                                  key: 1,
                                  "shipping-address": $options.shippingAddress,
                                  "shipping-model": $props.pledge.pledgeDetails.shippingModel,
                                  "can-change-shipping-address": $props.pledge.canChangeShipping,
                                  onChangeShipping: $options.onChangeShipping
                                }, null, 8 /* PROPS */, ["shipping-address", "shipping-model", "can-change-shipping-address", "onChangeShipping"]))
                              : ($options.hasAddressHidden)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.YourPledge.ShippingSectionHeader), 1 /* TEXT */),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_base_icon, { name: "info" }),
                                      _createTextVNode(" " + _toDisplayString($options.shippingInfoNotification), 1 /* TEXT */)
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                          ($options.hasPaymentOverview)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.Resources.YourPledge.PaymentMethodSectionHeader), 1 /* TEXT */),
                                ($options.isPaymentMethodInstant)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_localize, {
                                        tag: "div",
                                        resource: _ctx.Resources.YourPledge.PaymentMethodInfoInstantPaymentText,
                                        class: "gfu-bt gfu-bt--b2 _mb-3 _mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: $options.projectContactUrl,
                                            class: "_tc--accent",
                                            "format-key": "0",
                                            "data-qa": "your-pledge-link:ContactTheCreator"
                                          }, _toDisplayString(_ctx.Resources.YourPledge.PaymentMethodInfoInstantPaymentTextLink), 9 /* TEXT, PROPS */, _hoisted_7)
                                        ]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["resource"]),
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_base_image, {
                                            src: $options.paymentOverviewDetails.imageUrl,
                                            alt: $options.paymentOverviewDetails.name,
                                            height: "20"
                                          }, null, 8 /* PROPS */, ["src", "alt"]),
                                          _createElementVNode("span", _hoisted_10, _toDisplayString($options.paymentOverviewDetails.name), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("ul", _hoisted_11, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.paymentMethodDisclaimer, (item) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: item.iconName,
                                              class: "_flex"
                                            }, [
                                              _createVNode(_component_base_icon, {
                                                class: "_mr-2 _tc--accent _shrink-0 _py-h",
                                                size: "lg",
                                                "is-fixed-width": true,
                                                name: item.iconName
                                              }, null, 8 /* PROPS */, ["name"]),
                                              _createElementVNode("div", _hoisted_12, _toDisplayString(item.paragraph), 1 /* TEXT */)
                                            ]))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", _hoisted_13, _toDisplayString($options.paymentMethodInfo), 1 /* TEXT */),
                                      (!$data.changeCreditCard)
                                        ? (_openBlock(), _createBlock(_component_credit_card_overview, {
                                            key: 0,
                                            "image-url": $options.paymentOverview.cardImageUrl,
                                            name: $options.paymentOverview.cardName,
                                            "masked-number": $options.paymentOverview.cardMaskedNumber,
                                            "payment-data-source": $options.paymentOverview.paymentDataSource,
                                            "payment-data-source-image-url": $options.paymentOverview.paymentDataSourceImageUrl,
                                            "payment-data-source-name": $options.paymentOverview.paymentDataSourceName
                                          }, {
                                            default: _withCtx(() => [
                                              ($options.paymentOverview.canChangeCreditCard)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: "#",
                                                    class: "gfu-link gfu-link--accent _mt-1",
                                                    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.toggleCardChange && $options.toggleCardChange(...args)), ["prevent"])),
                                                    "data-qa": "your-pledge-link:ChangeCard"
                                                  }, _toDisplayString(_ctx.Resources.YourPledge.ChangePaymentMethodButton), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["image-url", "name", "masked-number", "payment-data-source", "payment-data-source-image-url", "payment-data-source-name"]))
                                        : ($options.paymentOverview.canChangeCreditCard)
                                          ? (_openBlock(), _createBlock(_component_adyen_order_payment_options, {
                                              key: 1,
                                              "project-id": _ctx.projectContext.projectID,
                                              "project-phase": _ctx.projectContext.project.phase,
                                              "project-type": _ctx.projectContext.project.type,
                                              "is-instant": false,
                                              "require-accept-tos": false,
                                              "effective-payable-amount": $props.pledge.effectivePayableAmount,
                                              "currency-short-name": $props.pledge.currencyShortName,
                                              "order-code": $props.pledge.orderCode,
                                              "order-id": $props.pledge.orderID,
                                              "payment-type": $options.paymentType,
                                              reason: $options.paymentMethodReason,
                                              onPaymentError: $options.onPaymentError,
                                              onPaymentMethodChange: $options.onPaymentMethodChange,
                                              onPaymentMethodChanged: $options.onPaymentMethodChanged,
                                              onTogglePaymentGroupVisibilityChange: $options.onTogglePaymentGroupVisibilityChange
                                            }, {
                                              actions: _withCtx(({ onSubmit }) => [
                                                _createElementVNode("div", _hoisted_14, [
                                                  _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("a", {
                                                      href: "#",
                                                      class: "gfu-link _mr-3",
                                                      onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.toggleCardChange && $options.toggleCardChange(...args)), ["prevent"])),
                                                      "data-qa": "create-order-btn:Cancel"
                                                    }, _toDisplayString(_ctx.Resources.YourPledge.CancelPaymentMethodChangeButton), 1 /* TEXT */),
                                                    _createVNode(_component_base_button, {
                                                      theme: "accent",
                                                      class: "gfu-btn--wide gfu-btn--soft",
                                                      onClick: onSubmit,
                                                      "data-qa": "create-order-btn:Submit"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.SavePaymentMethodChangeButton), 1 /* TEXT */)
                                                      ]),
                                                      _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                  ])
                                                ])
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["project-id", "project-phase", "project-type", "effective-payable-amount", "currency-short-name", "order-code", "order-id", "payment-type", "reason", "onPaymentError", "onPaymentMethodChange", "onPaymentMethodChanged", "onTogglePaymentGroupVisibilityChange"]))
                                          : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */)),
              (_ctx.promoItem)
                ? (_openBlock(), _createBlock(_component_project_promo_item, {
                    key: 2,
                    "image-size": 48,
                    "in-context": false,
                    class: "gfu-isle gfu-isle--primary-light _pa-2 _mt-3",
                    "data-qa": "your-pledge-project-promo-item"
                  }))
                : _createCommentVNode("v-if", true),
              ($options.isUnfinishedOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    ($options.canRevertChanges)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("a", {
                            class: "gfu-link gfu-link--accent",
                            onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => ($options.revertChanges && $options.revertChanges(...args)), ["stop","prevent"])),
                            "data-qa": "your-pledge-button:Revert"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.YourPledge.RevertChangesButtonLong), 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.hasAddMoreButton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_base_button, {
                            theme: "primary",
                            display: "fixed",
                            shape: "default",
                            onClick: _withModifiers($options.onAddItemsToOrder, ["stop","prevent"]),
                            "data-qa": "your-pledge-button:AddItems"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.AddMoreButton), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onClick"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_19, [
                      ($options.canProceedToCheckout)
                        ? (_openBlock(), _createBlock(_component_go_to_checkout, {
                            key: 0,
                            "redirect-on-alternative-action": false,
                            "continue-url": _ctx.cartSummary.checkoutUrl,
                            "order-code": $props.pledge.cartTableOrderCode
                          }, {
                            default: _withCtx(({ onInvoke }) => [
                              _createVNode(_component_base_button, {
                                enabled: $options.canProceedToCheckout,
                                theme: "accent",
                                display: "block",
                                onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                                "data-qa": "your-pledge-checkout-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.Resources.YourPledge.CheckoutButton), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["enabled", "onClick"])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["continue-url", "order-code"]))
                        : (_openBlock(), _createBlock(_component_tooltip, {
                            key: 1,
                            text: $options.disabledCheckoutTooltipText
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.Resources.YourPledge.CheckoutButton), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["text"]))
                    ])
                  ]))
                : ($options.canSetShipping)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_go_to_checkout, {
                          "redirect-on-alternative-action": false,
                          "continue-url": _ctx.cartCandidate.manageShippingUrl,
                          "order-code": _ctx.cartCandidate.orderCode
                        }, {
                          default: _withCtx(({ onInvoke }) => [
                            _createElementVNode("a", {
                              class: "gfu-btn gfu-btn--soft gfu-btn--accent gfu-btn--block",
                              href: _ctx.cartCandidate.manageShippingUrl,
                              onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                              "data-qa": "your-pledge-checkout-btn"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.Resources.YourPledge.SetShippingButton), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_23)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["continue-url", "order-code"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.isPaymentHistoryModalOpen)
          ? (_openBlock(), _createBlock(_component_pledge_payment_history_modal, {
              key: 2,
              "order-id": $options.paymentHistoryOrderId,
              "pledge-id": $props.pledge.orderPublicID,
              "is-open": $data.isPaymentHistoryModalOpen,
              onActionClose: $options.onPaymentHistoryModalClose
            }, null, 8 /* PROPS */, ["order-id", "pledge-id", "is-open", "onActionClose"]))
          : _createCommentVNode("v-if", true),
        ($props.pledge.pledgeDetails)
          ? (_openBlock(), _createBlock(_component_order_stage_history_modal, {
              key: 3,
              "is-open": $data.isOrderStageHistoryModalOpen,
              "order-id": $options.orderId,
              "order-public-id": $props.pledge.pledgeDetails.orderPublicID,
              onActionClose: $options.onOrderStageHistoryModalClose
            }, null, 8 /* PROPS */, ["is-open", "order-id", "order-public-id", "onActionClose"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}